const formsList = [
  {
    type: "section",
    category: ["all", "listing"],
    formNumber: null,
    title: "Listing Forms",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "MLS-listing-contract",
    title: "MLS Real Estate Listing Contract",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "form-e",
    title: "Form E - Seller Service Agreement",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "mls-marketing-release",
    title: "Marketing Release Date - Multiple Listing Schedule",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "direction-offers",
    title: "Sellers Direction of Showings/Offers",
  },

  {
    type: "form",
    category: ["all", "listing", "purchase"],
    formNumber: "mb-wwar",
    title: "Working with a REALTOR® Brochure",
  },
  {
    type: "section",
    category: ["all", "listing"],
    formNumber: null,
    title: "Purchase Forms",
  },
  {
    type: "form",
    category: ["all", "listing"],
    formNumber: "limited-joint-representation",
    title: "Acknowledgement of Limited Joint Representation",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "sch1-res-pds",
    title: "Schedule 1 - Residential Property Disclosure Statement",
  },
  {
    type: "form",
    category: ["all", "purchase"],
    formNumber: "sch1-condo-pds",
    title: "Schedule 1 - Condo Property Disclosure Statement",
  },
];

export default formsList;
